import { useSelector } from 'react-redux'
import { RootState } from '../../redux-store'
import styled from '@emotion/styled'
import { useRouter } from '../../utils/helper'
import { home, insuranceDetail } from '../../constant/path'
import { useScreen } from '../../utils/responsive-helper'
import Headbar from '../../components/common/HeadBar'
import { useTranslation } from 'react-i18next'
import { mobile } from '../../utils/responsive-helper'
import InsuranceForm from './InsuranceForm'
import color from '../../constant/colors'
import { useGetInsuranceById } from '../../services/insurance/insurance-query'
import { InsuranceInfoWithConcentDate, InsuranceInfoWithoutConcentDate } from '../../redux-store/insurance-reducer'

const BackgroundHeader = styled.div`
  background-color: ${color.CHOICES_PRIMARY};
  width: calc(100% - 32px);
  height: 266px;
  margin-top: 0px !important;
  position: absolute;

  ${mobile} {
    width: 100%;
  }
`
const Layout = styled.div`
  width: 768px;
  margin: 0 auto;
  z-index: 1;
  > * {
    margin-top: 24px;
  }

  ${mobile} {
    width: 100%;
  }
`

const InsuranceSummary = () => {
  const { query } = useRouter<{ insuranceId: number }>()
  const { data: insuranceItem, isLoading } = useGetInsuranceById({ claimId: query.insuranceId })

  const InsuranceFormValue = useSelector((state: RootState) => state.insurance.InsuranceInfo) as InsuranceInfoWithoutConcentDate & InsuranceInfoWithConcentDate
  return (
    <>
      <BackgroundHeader />
      <Layout>
        <Headbar title={insuranceItem?.name || ''} backWard={insuranceDetail({ routeParam: { insuranceId: query.insuranceId } })} />
        {/* <EClaimInfo eClaimItem={eClaimItem} editable={false} /> */}
        <InsuranceForm
          insuranceItem={insuranceItem}
          insuranceId={query.insuranceId}
          insuranceFormValue={InsuranceFormValue}
          editable={false}
          isPreview={true}
        />
      </Layout>
    </>
  )
}

export default InsuranceSummary
